/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getSourceProductionFields } from '../../store/reducers/Nominations/FieldNoms';
import { IFullState } from '../../types/All.type';
import { ISelectOptions } from '../../types/Common.type';

type GetSourceProductionFieldsType = (fieldMapping?: boolean) => {
  loadingSourceProductionFields: boolean;
  sourceProductionFields: ISelectOptions[];
};

const useGetSourceProductionFields: GetSourceProductionFieldsType = () => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector(
    (state: IFullState) => state.FieldNoms.sourceProductionField,
  );

  useEffect(() => {
    if (data.length === 0 && !loading && !error) {
      dispatch(getSourceProductionFields());
    }
  }, [data]);

  return {
    loadingSourceProductionFields: loading,
    sourceProductionFields: data.filter((field) => field.isVisible),
  };
};

export default useGetSourceProductionFields;
